// ============================================================================
// ADMIN MCP STATUS SERVICE
// Platform-wide, read-only visibility into project-level MCP enablement.
// Never returns any token — enabled/write flags and active token count only.
// ============================================================================

import { api } from './api';

export interface ProjectMcpStatus {
  projectId: string;
  name: string;
  organizationId: string;
  mcpEnabled: boolean;
  mcpWriteEnabled: boolean;
  activeTokenCount: number;
}

export type McpAccessState = 'off' | 'readonly' | 'write';

export async function listProjectMcpStatus(): Promise<{ projects: ProjectMcpStatus[]; total: number }> {
  const response = await api.get('/api/admin/mcp-status/projects');
  return response.data;
}

export async function setProjectMcpState(projectId: string, state: McpAccessState): Promise<void> {
  await api.patch(`/api/admin/mcp-status/projects/${projectId}/state`, { state });
}

/** Revokes every member's personal token on the project. */
export async function revokeProjectMcpToken(projectId: string): Promise<number> {
  const response = await api.post(`/api/admin/mcp-status/projects/${projectId}/revoke-token`);
  return response.data.revoked ?? 0;
}
